import { css, type Theme } from "@emotion/react";

import { dimensions, animations } from "@styles";
import { cardShadow } from "@styles/emotion-styles/baseStyles";

export const wrapper = {
  base: css`
    border-radius: ${dimensions.cardRadius};
  `,
  enabled: (theme: Theme) => css`
    ${cardShadow(theme)};
    background-color: ${theme.surface.interactiveBackground};
  `,
  enabledBorder: (theme: Theme) => css`
    border: 1px solid ${theme.system.borderBase};
    box-shadow: none;
  `,
  muted: (theme: Theme) => css`
    background-color: ${theme.system.backgroundMuted};
    box-shadow: none;
    border: none;
  `,
};

export const triggerWrapper = {
  base: css`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
  `,
  coreContent: css`
    flex-basis: 90%;
  `,
  secondaryContent: css`
    align-items: center;
  `,
  bothContent: css`
    flex-basis: 70%;
  `,
  withChevron: css`
    display: flex;
    column-gap: 0.5rem;
  `,
};

export const triggerButton = {
  base: (theme: Theme) => css`
    padding: 0;
    width: 100%;
    border: 1px solid transparent;
    ${animations.transition()}

    &:not([disabled]) {
      cursor: pointer;
    }

    &[disabled] {
      color: ${theme.disabled.text};
      background-color: ${theme.disabled.background};
      border-color: ${theme.disabled.border};
      border-radius: ${dimensions.cardRadius};

      cursor: not-allowed;
    }
  `,
};

export const chevron = (theme: Theme) => css`
  color: ${theme.text.body};
  font-size: ${theme.aviaryTypography.caption.fontSize};
`;

export const padding = {
  medium: css`
    padding: 1rem;
  `,
  small: css`
    padding: 0.5rem;
  `,
  large: css`
    padding: 1.75rem;
  `,
};

export const frame = {
  base: css`
    will-change: transform, opacity, height;
    overflow: hidden;
  `,
  open: css`
    overflow: unset;
  `,
};
